import { Component, OnInit,Injector } from "@angular/core";
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import Swal from "sweetalert2";
import { DatePipe, DecimalPipe } from "@angular/common";
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { HttpErrorResponse } from "@angular/common/http";
import { DocumentoNegociableService } from "../../../services/documento-negociable/documento-negociable.service";
import { Router,ActivatedRoute } from '@angular/router';
import { MessagesTitles, MessagesGeneral, MessagesDates, MessagesStatus } from '../../../models/messages';
import { LoginService } from "app/services/login/login.service";
import { SecurityService } from "app/services/security/security.service";
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-recibo-honorario',
  templateUrl: './recibo-honorario.component.html',
  styleUrls: ['./recibo-honorario.component.css'],
  providers: [MessagesTitles,MessagesGeneral,MessagesDates,MessagesStatus,
    DatePipe,DecimalPipe,
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ReciboHonorarioComponent implements OnInit {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  comprobante:any;
  error1: boolean = false;
  error2: boolean = false;
  mensaje1: string;
  mensaje2: string;
  MONEDA: string;
  proveedor: any = {};
  adquirente: any = {} ;
  error: boolean = false;
  loading: boolean = false;
  mensaje: string;
  empresa: any = {};
  fileContent: any;
  xml: string;
  xml2: JSON;
  cuotasform: FormGroup;
  unaCuota: FormGroup;
  monedaElement: any;
  disable: boolean;
  longitud;
  MILISENGUNDOS_POR_DIA = 1000 * 60 * 60 * 24;

  public archivoEnBase64 : string;


  loadinButton:boolean=false;

  form: FormGroup;
  formSended : FormGroup;
  formArchivo: FormGroup;  
  titulo : string;
  comprobanteId: any; 
  update: boolean = false;
  action:string = "crear";
  user: any;
  usuario_com: any;
  negociabesService: DocumentoNegociableService;
  securityservice:SecurityService;
  loginService:LoginService;
  constructor(
    private injector:Injector,
    private datePipe: DatePipe, private router:Router,
    private decimalPipe: DecimalPipe,
    private msgTitulos : MessagesTitles,
    private activateRoute :ActivatedRoute,
    private messagesStatus:MessagesStatus
  ) {

    this.negociabesService = this.injector.get<DocumentoNegociableService>(DocumentoNegociableService);
    this.securityservice = this.injector.get<SecurityService>(SecurityService);
    this.loginService = this.injector.get<LoginService>(LoginService);
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.formArchivo = new FormGroup({
      'idComprobante' : new FormControl('',  Validators.required),
      'TipoAdjunto' : new FormControl(2,  [ Validators.required]),
      'file_content' : new FormControl('',  [ Validators.required])


    })
    this.cuotasform = new FormGroup({
      
      Cuotas: new FormArray([       
        new FormGroup({   
          'Fecha_de_Pago' : new FormControl('',  Validators.required),
          'Importe' : new FormControl('', [ Validators.required,  Validators.pattern("^^[0-9.,]+$")]),
          'Importe_Ejecutado': new FormControl("0"),
          'Importe_Pendiente': new FormControl(""),
        }),    new FormGroup({   
          'Fecha_de_Pago' : new FormControl('',  Validators.required),
          'Importe' : new FormControl('',  [ Validators.required,  Validators.pattern("^^[0-9.,]+$")]),
          'Importe_Ejecutado': new FormControl("0"),
          'Importe_Pendiente': new FormControl(""),
        })
        
      ]),
      Estado: new FormControl('R', []),

    });
    this.longitud =   this.cuotasform.controls["Cuotas"]["controls"].length;


    this.form = new FormGroup({
      Tipo_Comprobante: new FormControl("R", [Validators.maxLength(1)  ]),
      Tipo_Emision: new FormControl("E", []),
      idProveedor: new FormControl("", []),
      idAdquirente: new FormControl("", []),
      archivo: new FormControl("", []),
      Ajustes: new FormControl({ value: "0.0", disabled: true }, []),
      VNPP_ICLV : new FormControl("", []),
      Alta_Fecha : new FormControl("", []),
      Alta_Usuario : new FormControl(this.user.Usuario, []),
      Usuario_Comercial: new FormControl("", []),
      Alta_Canal : new FormControl("W", []),
      Baja_Fecha : new FormControl(null, []),
      Baja_Usuario : new FormControl(null, []),
      Baja_Canal : new FormControl(null, []),
      IGV_Exonerado : new FormControl(35, []),
      IGV_Porcentaje : new FormControl(0, []),
     
     
      Otros_Descuentos: new FormControl("0.0", [Validators.pattern("^[0-9.,]+$") ]),
      rucAdquirente: new FormControl({ value: "", disabled: true }, [
        Validators.minLength(11),Validators.required
      ]),
    
      razSocial: new FormControl({ value: "", disabled: true }, [Validators.required]),
      dirFiscal: new FormControl({ value: "", disabled: true }, [Validators.required]),
      departamento: new FormControl({ value: "", disabled: true }, [Validators.required]),
      provincia: new FormControl({ value: "", disabled: true }, [Validators.required]),
      distrito: new FormControl({ value: "", disabled: true }, [Validators.required]),
      

      rucProveedor: new FormControl({ value: "", disabled: true }, [ Validators.minLength(11),Validators.required]),
      razSocialProveedor: new FormControl({ value: "", disabled: true }, [Validators.required]),
      dirFiscalProveedor: new FormControl({ value: "", disabled: true }, [Validators.required]),
      departamentoProveedor: new FormControl({ value: "", disabled: true }, [Validators.required]),
      provinciaProveedor: new FormControl({ value: "", disabled: true }, [Validators.required]),
      distritoProveedor: new FormControl({ value: "", disabled: true }, [Validators.required]),


      // Autorizacion: new FormControl("", [Validators.required]),
      Serie: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Numero: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Fecha_Emision: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Moneda: new FormControl({ value: "", disabled: true }, [Validators.required]),

      Descripcion: new FormControl("", [  Validators.maxLength(100),Validators.required]),
      Fecha_Vencimiento: new FormControl("", [Validators.required]),
      Fecha_Entrega: new FormControl( "1900-01-01"),
      VNPP: new FormControl("", [Validators.required]),
      Fecha_de_Pago: new FormControl( "", [Validators.required]),
      cuotas: new FormControl(false, []),
      Tipo_Pago : new FormControl("C", []),
      Numero_Cuotas: new FormControl({ value: 1, disabled: true }, [  Validators.maxLength(2)]),

      // Retencion_Importe: new FormControl({ value: "", disabled: true }, [Validators.required]),

      //   Total_Honorarios: new FormControl({ value: "", disabled: true }, [Validators.required]),
      //   Total_Recibido: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Retencion_Importe: new FormControl({ value: '0.0', disabled: false }, [Validators.required]),
      Retencion_Porcentaje: new FormControl({ value: '0.0', disabled: true }, [Validators.required]),

      Total_Honorarios: new FormControl({ value: '0.0', disabled: false }, [Validators.required]),
      Total_Recibido: new FormControl({ value: '0.0', disabled: true }, [Validators.required]),

    });


    this.formSended = new FormGroup({
      Tipo_Comprobante: new FormControl("R", [Validators.maxLength(1)  ]),
      Tipo_Emision: new FormControl("E", []),
      idProveedor: new FormControl("", []),
      idAdquirente: new FormControl("", []),
      archivo: new FormControl("", []),
      Ajustes: new FormControl({ value: "0.0", disabled: true }, []),
      VNPP_ICLV : new FormControl("", []),
      Alta_Fecha : new FormControl("", []),
      Alta_Usuario : new FormControl(this.user.Usuario, []),
      Usuario_Comercial: new FormControl("", []),
      Alta_Canal : new FormControl("W", []),
      Baja_Fecha : new FormControl(null, []),
      Baja_Usuario : new FormControl(null, []),
      Baja_Canal : new FormControl(null, []),
      IGV_Exonerado : new FormControl(35, []),
      IGV_Porcentaje : new FormControl(0, []),
     
     
      Otros_Descuentos: new FormControl("0.0", [Validators.pattern("^[0-9.,]+$") ]),
      rucAdquirente: new FormControl({ value: "", disabled: true }, [
        Validators.minLength(11),Validators.required
      ]),
    
      razSocial: new FormControl({ value: "", disabled: true }, [Validators.required]),
      dirFiscal: new FormControl({ value: "", disabled: true }, [Validators.required]),
      departamento: new FormControl({ value: "", disabled: true }, [Validators.required]),
      provincia: new FormControl({ value: "", disabled: true }, [Validators.required]),
      distrito: new FormControl({ value: "", disabled: true }, [Validators.required]),
      

      rucProveedor: new FormControl({ value: "", disabled: true }, [ Validators.minLength(11),Validators.required]),
      razSocialProveedor: new FormControl({ value: "", disabled: true }, [Validators.required]),
      dirFiscalProveedor: new FormControl({ value: "", disabled: true }, [Validators.required]),
      departamentoProveedor: new FormControl({ value: "", disabled: true }, [Validators.required]),
      provinciaProveedor: new FormControl({ value: "", disabled: true }, [Validators.required]),
      distritoProveedor: new FormControl({ value: "", disabled: true }, [Validators.required]),


      // Autorizacion: new FormControl("", [Validators.required]),
      Serie: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Numero: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Fecha_Emision: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Moneda: new FormControl({ value: "", disabled: true }, [Validators.required]),

      Descripcion: new FormControl("", [  Validators.maxLength(100),Validators.required]),
      Fecha_Vencimiento: new FormControl("", [Validators.required]),
      Fecha_Entrega: new FormControl( "1900-01-01"),
      VNPP: new FormControl("", [Validators.required]),
      Fecha_de_Pago: new FormControl( "", [Validators.required]),
      cuotas: new FormControl(false, []),
      Tipo_Pago : new FormControl("C", []),
      Numero_Cuotas: new FormControl({ value: 1, disabled: true }, [  Validators.maxLength(2)]),

      // Retencion_Importe: new FormControl({ value: "", disabled: true }, [Validators.required]),

      //   Total_Honorarios: new FormControl({ value: "", disabled: true }, [Validators.required]),
      //   Total_Recibido: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Retencion_Importe: new FormControl({ value: '0.0', disabled: false }, [Validators.required]),
      Retencion_Porcentaje: new FormControl({ value: '0.0', disabled: true }, [Validators.required]),

      Total_Honorarios: new FormControl({ value: '0.0', disabled: false }, [Validators.required]),
      Total_Recibido: new FormControl({ value: '0.0', disabled: true }, [Validators.required]),

    });
  }



  ngOnInit() {
    this.listarUsuariosComercial();
    this.titulo = "Registro de Recibo por Honorarios";
    this.activateRoute.params.subscribe( params => {
      if(params['id'] != undefined){
        this.loading = true;
        this.action = params['action'];
        this.comprobanteId = params['id'];
        this.update = true;
        this.titulo = "Editar de Recibo por Honorarios";
        this.negociabesService.obtenerDocNegociablesById(this.comprobanteId)
        .subscribe(res => {
            this.loading = false;
            this.form.controls['Serie'].setValue(res[0]['Serie']);  
            this.form.controls['Numero'].setValue(res[0]['Numero']);  
            this.form.controls['Fecha_Emision'].setValue(res[0]['Fecha_Emision']);  
            this.form.controls['rucProveedor'].setValue(res[0]['Num_Doc_Identificacion']); 
            this.form.controls['idProveedor'].setValue(res[0]['idProveedor']); 
            this.form.controls['idAdquirente'].setValue(res[0]['idAdquirente']); 
            this.form.controls['razSocialProveedor'].setValue(res[0]['Razon_Social']); 
            this.form.controls['dirFiscalProveedor'].setValue(res[0]['Direccion_Fiscal']); 
            this.form.controls['departamentoProveedor'].setValue(res[0]['Departamento']); 
            this.form.controls['provinciaProveedor'].setValue(res[0]['Provincia']); 
            this.form.controls['distritoProveedor'].setValue(res[0]['Distrito']);             
            this.form.controls['rucAdquirente'].setValue(res[0]['Num_Doc_IdentificacionAdq']);            
            this.form.controls['razSocial'].setValue(res[0]['Razon_SocialAdq']); 
            this.form.controls['dirFiscal'].setValue(res[0]['Direccion_FiscalAdq']); 
            this.form.controls['departamento'].setValue(res[0]['departamentoAdq']); 
            this.form.controls['provincia'].setValue(res[0]['provinciaAdq']); 
            this.form.controls['distrito'].setValue(res[0]['distritoAdq']);
            this.form.controls['Moneda'].setValue(res[0]['Moneda']);  
            this.form.controls['Total_Honorarios'].setValue(res[0]['Total_Honorarios']);  
            this.form.controls['Retencion_Importe'].setValue(res[0]['Retencion_Importe_RH']);  
            this.form.controls['Total_Recibido'].setValue(res[0]['Total_Recibido']);  
            this.form.controls['Descripcion'].setValue(res[0]['Descripcion']);  
            this.form.controls['Fecha_Entrega'].setValue(res[0]['Fecha_Entrega']);  
            this.form.controls['Fecha_Vencimiento'].setValue(res[0]['Fecha_Vencimiento']);  
            this.form.controls['Fecha_de_Pago'].setValue(res[0]['Fecha_de_Pago']);  
            this.form.controls['VNPP'].setValue(res[0]['VNPP']);
            this.form.controls['Usuario_Comercial'].setValue(res[0]['Usuario_Comercial']);
            if(res[0]['NroCuotas'] > 1){
              
              this.form.controls['cuotas'].setValue(true);              
              this.form.controls['Numero_Cuotas'].setValue(res[0]['NroCuotas']);                          
              this.longitud = res[0]['NroCuotas'];              
              for(let i = 0; i < res[0]['NroCuotas']; i++){
                
                this.agregarCuotas();
                
                this.cuotasform.controls["Cuotas"]["controls"][i]["controls"]["Fecha_de_Pago"].setValue(res["cuotas"][i]["Fecha_de_Pago"]);
                this.cuotasform.controls["Cuotas"]["controls"][i]["controls"]["Importe"].setValue(res["cuotas"][i]["Importe"]);
              }
            }
            this.form.controls['Otros_Descuentos'].setValue(res[0]['Otros_Descuentos']);  
            this.form.controls['Ajustes'].setValue(res[0]['Ajustes']); 

            this.monedaElement = res[0]['Moneda'] ; 
            if(this.action == "ver"){
              this.desactivarFormulario();
            }
        }, err => {
          this.loading = false;
        });
      }
      
    })
  }

  tipoMoneda(event){
    this.form.controls['Moneda'].setValue(event);
    this.formSended.controls['Moneda'].setValue(event);
  }

  listarUsuariosComercial(){
    let TipoUsuario = "COM";
    this.securityservice.ObtenerUsuarios(TipoUsuario).subscribe(res =>{     
      this.usuario_com = res;
    })
  }
  
  desactivarFormulario(){
    this.form.disable();
    this.cuotasform.disable();
    this.disable = true;
  }
  transformarDatosParaEnviar() {
    this.formSended.setValue(this.form.getRawValue());

    if (this.formSended.controls["Usuario_Comercial"].value == "") {
      this.formSended.controls["Usuario_Comercial"].setValue(this.user.Usuario);
    }
    
    let retencion =  this.cortarComa(this.formSended.controls['Retencion_Importe'].value);
    let totalHonorarios =  this.cortarComa(this.formSended.controls['Total_Honorarios'].value);
    let porcentaje = Number((retencion * 100) / totalHonorarios);

    this.formSended.controls['Retencion_Porcentaje'].setValue(porcentaje.toFixed(2));

    this.formSended.controls["Alta_Fecha"].setValue(
      this.datePipe.transform(Date(), "yyyy-MM-dd  HH:mm:ss")
    );

    this.formSended.controls["Fecha_Vencimiento"].setValue(
      this.datePipe.transform(
        this.formSended.controls["Fecha_Vencimiento"].value,
        "yyyy-MM-dd"
      )
    );

    this.formSended.controls["Fecha_Entrega"].setValue(
      this.datePipe.transform(
        this.formSended.controls["Fecha_Entrega"].value,
        "yyyy-MM-dd"
      )
    );

    this.formSended.controls["Fecha_de_Pago"].setValue(
      this.datePipe.transform(this.formSended.controls["Fecha_de_Pago"].value, "yyyy-MM-dd")
    );

    this.formSended.controls["Fecha_Emision"].setValue(
      this.datePipe.transform(
        new Date(this.formSended.controls["Fecha_Emision"].value),
        "yyyy-MM-dd"
      )
    );

    if (this.formSended.controls["Moneda"].value == "USD") {
      this.formSended.controls["Moneda"].setValue(3);
    } else {
      this.formSended.controls["Moneda"].setValue(2);
    }

    if (this.formSended.controls["cuotas"].value == true) {
      this.formSended.controls["Tipo_Pago"].setValue("C");
      this.formSended.controls["Numero_Cuotas"].setValue(this.cuotasform.controls["Cuotas"]["controls"].length);
    } else {
      this.formSended.controls["Tipo_Pago"].setValue("U");
      this.formSended.controls["Numero_Cuotas"].setValue(1);
    }

    

    this.formSended.controls['Total_Honorarios'].setValue(this.cortarComa(this.form.controls['Total_Honorarios'].value));
    this.formSended.controls['Total_Recibido'].setValue(this.cortarComa(this.form.controls['Total_Recibido'].value));
    this.formSended.controls['Retencion_Importe'].setValue(this.cortarComa(this.form.controls['Retencion_Importe'].value));
    this.formSended.controls['VNPP'].setValue(this.cortarComa(this.form.controls['VNPP'].value));
    this.formSended.controls['VNPP_ICLV'].setValue(this.cortarComa(this.form.controls['VNPP'].value));
    this.formSended.controls["Otros_Descuentos"].setValue( this.cortarComa(this.form.controls["Otros_Descuentos"].value));
    
  }


  guardarCambios() {  
    

    if (this.form.controls['cuotas'].value){      
          let ultimaCuota = this.longitud-1;
          let ultimaFechaCuota = this.cuotasform.controls["Cuotas"]["controls"][ultimaCuota]["controls"]["Fecha_de_Pago"].value;
          
          if (this.datePipe.transform(this.form.controls["Fecha_de_Pago"].value,'yyyy-MM-dd') != this.datePipe.transform(ultimaFechaCuota,'yyyy-MM-dd')) {
            Swal.fire({
              title: "ERROR",
              text: "La Fecha de la última cuota no puede ser diferente que la Fecha de Pago",
              type: "warning",
              allowOutsideClick: true,
              heightAuto: false
            });
            return;
          }
          let pagos : any = 0;
      
          for (let index = 0; index < this.longitud; index++) {
            let p  = this.cortarComa(this.cuotasform.controls["Cuotas"]["controls"][index]["controls"]["Importe"].value);
             
            pagos += Number(p);
          }
          
          if (pagos != this.cortarComa(this.form.controls['VNPP'].value)) {
            Swal.fire({
              title: "Error",
              text: "La suma de las cuotas es diferente al VNPP",
              type: "warning",
              allowOutsideClick: true,
              heightAuto: false
            });
            return;
          }

           for (let index = 0; index < this.longitud; index++) {
              
            if (  this.cuotasform.controls["Cuotas"]["controls"][index]["controls"]["Fecha_de_Pago"].value > this.form.controls["Fecha_de_Pago"].value) {

              Swal.fire({
                title: "Error",
                text: "La Fecha de las cuotas no puede ser mayor a la Fecha de Pago",
                type: "warning",
                allowOutsideClick: true,
                heightAuto: false
              });
                return;
            }
          }

    }
    
    Swal.fire({
      title: 'Espere',
      text:'Guardado Información',
      type:'info',
      allowOutsideClick:false,
      heightAuto: false
    });
    Swal.showLoading();
    this.loadinButton = true;

    try {
      
      this.transformarDatosParaEnviar();
     this.transformarImporteCuotas();
     
     
     if(this.update){
      this.editar();
    }else{
      this.crear();
     }
    } catch (error) {
     
      this.loadinButton = false;

      this.mensaje = "Error al guardar Documento Negociable - Llamar a Soporte";
    Swal.fire({
      title: "ERROR GRAVE",
      text: this.mensaje,
      type: "error",
      allowOutsideClick: true,
      heightAuto: false
    });
     
    }
  }

  crear(){
    this.negociabesService
        .crearDocNegociable(this.formSended.getRawValue())
        .subscribe(data => {
          this.comprobante = data;
          let idComprobante = this.comprobante['idComprobante'];

          this.formArchivo.controls['idComprobante'].setValue(idComprobante);
            this.formArchivo.controls['file_content'].setValue(this.archivoEnBase64);

          if (this.form.controls['cuotas'].value == true){
              
            this.transformarFechas();
          this.negociabesService.crearCuotas(this.cuotasform.getRawValue(),idComprobante).subscribe(res => {

            this.negociabesService.guardarArchivoGDrive(this.formArchivo.value)
                  .subscribe(resp => {

                    Swal.fire({
                      title: "Success",
                      text:'Documento Registrado Correctamente',
                      type: "success",
                      allowOutsideClick: false,
                      heightAuto: false
                    }).then(resp2 => {
                      if (resp2.value == true) {
                        this.goBack();
                      }
                    });

                  })
          },
          (err: HttpErrorResponse)=> {
            this.messagesStatus.getMessage(err.status);  
            
            Swal.fire({
              title: "ERROR",
              text: 'CUOTA NO REGISTRADA. '+ this.messagesStatus.message,
              type: "error",
              allowOutsideClick: false,
              heightAuto: false
            })
      
          });
          }else {
            let FP = this.formSended.controls['Fecha_de_Pago'].value;
  
            this.unaCuota = new FormGroup({
              Cuotas: new FormArray([
                new FormGroup({
                  Fecha_de_Pago: new FormControl(FP),
                  Importe: new FormControl(this.formSended.controls['VNPP'].value, []),
                  Importe_Ejecutado: new FormControl(0, []),
                  Importe_Pendiente: new FormControl(this.formSended.controls['VNPP'].value, [])
                }),
               ]),
              Estado: new FormControl("R", [])
            });


            this.negociabesService
            .crearCuotas(this.unaCuota.getRawValue(), idComprobante)
            .subscribe(
              res => {
                this.negociabesService.guardarArchivoGDrive(this.formArchivo.value)
                    .subscribe(resp => {

                      Swal.fire({
                        title: "Success",
                        text: "Documento Registrado Correctamente",
                        type: "success",
                        allowOutsideClick: false,
                        heightAuto: false
                      }).then(resp3 => {
                        if (resp3.value == true) {
                          this.goBack();
                        }
                      });

                    })
              },
              (err: HttpErrorResponse)=> {
                this.messagesStatus.getMessage(err.status);    
             
                Swal.fire({
                  title: "ERROR",
                  text: "CUOTA NO REGISTRADA. "+ this.messagesStatus.message,
                  type: "error",
                  allowOutsideClick: false,
                  heightAuto: false
                });
              }
            );

          }
        }, err => {

          for (let index = 0; index < this.longitud; index++) {

            this.tranformarDecimalCuotas(index,'Importe');
            
            
          }

          this.loadinButton = false;

          Swal.fire({
            title: this.msgTitulos.Error_Algo_Salio_Mal,
           // text: err.error.message,
           text: err.error.Fecha_de_Pago+" ."+this.messagesStatus.message,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          });
        });
  }

  editar(){
    this.negociabesService
      .actualizarDocNegociable(this.formSended.getRawValue(),this.comprobanteId)
      .subscribe(
        data => {
          this.comprobante = data;
          this.mensaje1 = "Documento actualizado correctamente"; 
          if (this.form.controls["cuotas"].value == true) {
            this.transformarFechas();
            this.negociabesService
              .crearCuotas(this.cuotasform.getRawValue(), this.comprobanteId)
              .subscribe(
                res => {
                  Swal.fire({
                    title: "Success",
                    text: "Recibo registrado correctamente.",
                    type: "success",
                    allowOutsideClick: false,
                    heightAuto: false
                  }).then(resp => {
                    if (resp.value == true) {
                      this.goBack();
                    }
                  });
                },
                (err: HttpErrorResponse)=> {
                  this.messagesStatus.getMessage(err.status);  
             
                  Swal.fire({
                    title: "Error",
                    text: "CUOTA NO REGISTRADA. " + this.messagesStatus.message,
                    type: "error",
                    allowOutsideClick: false,
                    heightAuto: false
                  });
                }
              );
          } else {
            let FP = this.formSended.controls['Fecha_de_Pago'].value;
            this.unaCuota = new FormGroup({
              Cuotas: new FormArray([
                new FormGroup({
                  Fecha_de_Pago: new FormControl(FP),
                  Importe: new FormControl(this.formSended.controls['VNPP'].value, []),
                  Importe_Ejecutado: new FormControl(0, []),
                  Importe_Pendiente: new FormControl(this.formSended.controls['VNPP'].value, [])
                }),
               ]),
              Estado: new FormControl("R", [])
            });
            this.negociabesService
            .crearCuotas(this.unaCuota.getRawValue(), this.comprobanteId)
            .subscribe(
              res => {
                Swal.fire({
                  title: "Success",
                  text: "Recibo Registrado Correctamente",
                  type: "success",
                  allowOutsideClick: false,
                  heightAuto: false
                }).then(resp1 => {
                  if (resp1.value == true) {
                    this.goBack();
                  }
                });
              },
              (err1: HttpErrorResponse)=> {
                this.messagesStatus.getMessage(err1.status);   
            
                Swal.fire({
                  title: "Error",
                  text: "CUOTA NO REGISTRADA. "+ this.messagesStatus.message,
                  type: "error",
                  allowOutsideClick: false,
                  heightAuto: false
                });
              }
            );
          }
        },
        (err: HttpErrorResponse)=> {
          this.messagesStatus.getMessage(err.status); 
      
          for (let index = 0; index < this.longitud; index++) {
            this.tranformarDecimalCuotas(index,'Importe');
          }
          Swal.fire({
            title: this.msgTitulos.Error_Leve,
            text: "ERROR AL ACTUALIZAR. " + this.messagesStatus.message,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          });
        }
      );
  }

  validar(){
    if(this.error1){
      Swal.fire({
        title: "Algo salio mal!",
        text: "Proveedor bloqueado.",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }
    if(this.error2){
      Swal.fire({
        title: "Algo salio mal!",
        text: "Adquirente bloqueado.",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }
    if (this.form.invalid) {
      Swal.fire({
        title: "Algo salio mal!",
        text: "No puedes dejar campos vacíos",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }

    if (Math.abs(this.form.controls['Ajustes'].value) > 2) {
      Swal.fire({
        title: "Error",
        text: "Hay un Ajuste mayor a 2 unidades monetarias",
        type: "warning",
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }

    let fechaEmision = this.datePipe.transform(
      this.form.controls["Fecha_Emision"].value,
      "yyyy-MM-dd"
    );

    sessionStorage.setItem('FechaEmit', 
      this.form.controls["Fecha_Emision"].value) ;
      let fechaHoyUSD = new Date();
      let fechaEmiDif = new Date(this.form.controls["Fecha_Emision"].value);

      let diferencia6Meses = this.diferenciaEntreDiasEnDias(
        fechaHoyUSD,
        fechaEmiDif
      );

      if (Math.abs(diferencia6Meses) > 180) {
        Swal.fire({
          title: "ERROR",
          text: "La Fecha de Emision no puede ser menor a 6 meses",
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });
        return;
      }
 
    let fechaHoy = this.datePipe.transform(Date(), "yyyy-MM-dd");

    if (
      this.form.controls["Fecha_Emision"].value >
      this.form.controls["Fecha_Vencimiento"].value
    ) {
      alert("La fecha de Emision no puede ser mayor a la de vencimiento");
      Swal.fire({
        title: "ERROR",
        text: "La fecha de Emision no puede ser mayor a la de vencimiento",
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }

    if (this.form.controls["Fecha_Vencimiento"].value > this.form.controls["Fecha_de_Pago"].value) {
      Swal.fire({
        title: "ERROR",
        text: "La Fecha de Pago no puede ser menor a la de Fecha de Vencimiento",
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }

    if (
      this.datePipe.transform(
        this.form.controls["Fecha_de_Pago"].value,
        "yyyy-MM-dd"
      ) < fechaHoy
    ) {
      Swal.fire({
        title: "ERROR",
        text: "La fecha de Pago no puede ser menor a la de hoy",
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }

    if (
      this.datePipe.transform(
        this.form.controls["Fecha_Vencimiento"].value,
        "yyyy-MM-dd"
      ) < fechaHoy
    ) {
      Swal.fire({
        title: "ERROR",
        text: "La fecha de Vencimiento no puede ser menor a la de hoy",
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      });
      return;
    }

    if (fechaEmision > fechaHoy) {
      Swal.fire({
        title: "ERROR",
        text: "La fecha de Emision no puede ser mayor a la de hoy",
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      });
    }
  }

  diferenciaEntreDiasEnDias(a, b) {
    var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

    return Math.floor((utc2 - utc1) / this.MILISENGUNDOS_POR_DIA);
  }

  crearFormulario(){
    this.form = new FormGroup({
      Tipo_Comprobante: new FormControl("R", [Validators.maxLength(1)  ]),
      Tipo_Emision: new FormControl("E", []),
      idProveedor: new FormControl("", []),
      idAdquirente: new FormControl("", []),
      archivo: new FormControl("", []),
      Ajustes: new FormControl({ value: "0.0", disabled: true }, []),
      VNPP_ICLV : new FormControl("", []),
      Alta_Fecha : new FormControl("2019-05-31 21:45:30", []),
      Alta_Usuario : new FormControl(this.user.Usuario, []),
      Usuario_Comercial:new FormControl("", []),
      Alta_Canal : new FormControl("W", []),
      Baja_Fecha : new FormControl(null, []),
      Baja_Usuario : new FormControl(null, []),
      Baja_Canal : new FormControl(null, []),
      IGV_Exonerado : new FormControl(35, []),
      IGV_Porcentaje : new FormControl(0, []),
  
      
      Otros_Descuentos: new FormControl("0.0", []),
      rucAdquirente: new FormControl({ value: "", disabled: true }, [
        Validators.minLength(11),Validators.required
      ]),
    
      razSocial: new FormControl({ value: "", disabled: true }, [Validators.required]),
      dirFiscal: new FormControl({ value: "", disabled: true }, [Validators.required]),
      departamento: new FormControl({ value: "", disabled: true }, [Validators.required]),
      provincia: new FormControl({ value: "", disabled: true }, [Validators.required]),
      distrito: new FormControl({ value: "", disabled: true }, [Validators.required]),
      

      rucProveedor: new FormControl({ value: "", disabled: true }, [ Validators.minLength(11),Validators.required]),
      razSocialProveedor: new FormControl({ value: "", disabled: true }, [Validators.required]),
      dirFiscalProveedor: new FormControl({ value: "", disabled: true }, [Validators.required]),
      departamentoProveedor: new FormControl({ value: "", disabled: true }, [Validators.required]),
      provinciaProveedor: new FormControl({ value: "", disabled: true }, [Validators.required]),
      distritoProveedor: new FormControl({ value: "", disabled: true }, [Validators.required]),


      // Autorizacion: new FormControl("", [Validators.required]),
      Serie: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Numero: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Fecha_Emision: new FormControl({ value: "", disabled: true }, [Validators.required]),
      Moneda: new FormControl({ value: "", disabled: true }, [Validators.required]),

      Descripcion: new FormControl("", [  Validators.maxLength(100),Validators.required]),
      Fecha_Vencimiento: new FormControl("", [Validators.required]),
      Fecha_Entrega: new FormControl( "1900-01-01"),
      VNPP: new FormControl("", [Validators.required]),
      Fecha_de_Pago: new FormControl( "", [Validators.required]),
      cuotas: new FormControl(false, []),
      Tipo_Pago : new FormControl("C", []),
      Numero_Cuotas: new FormControl({ value: 1, disabled: true }, [  Validators.maxLength(2)]),

      Retencion_Importe: new FormControl({ value: '0.0', disabled: false }, [Validators.required]),
      Retencion_Porcentaje: new FormControl({ value: '0.0', disabled: true }, [Validators.required]),

      Total_Honorarios: new FormControl({ value: '0.0', disabled: false }, [Validators.required]),
      Total_Recibido: new FormControl({ value: '0.0', disabled: true }, [Validators.required]),

    });
  }

  public onChange(fileList: FileList): void {
    
    this.crearFormulario();
    
    let file = fileList[0];
    let fileReader: FileReader = new FileReader();

    fileReader.onloadend = x => {
      this.fileContent = fileReader.result;
      this.xml = this.fileContent;

      const pen = this.xml.search('currencyID="PEN"');
      const usd = this.xml.search('currencyID="USD"');
      if (pen >= 0){
        this.MONEDA = this.xml.slice(pen+12,pen+15);
      }else{
        this.MONEDA = this.xml.slice(usd+12,usd+15);
      }


      try {

        this.xml2 = this.negociabesService.toXml(this.xml);

        const rucAdquirente = this.xml2["AccountingCustomerParty"]["CustomerAssignedAccountID"].trim();

        const rucProveedor = this.xml2["AccountingSupplierParty"]["CustomerAssignedAccountID"].trim();
        
        this.loading = true;
        this.validarEmpresa(rucAdquirente);
        this.validarProveedor(rucProveedor);

        setTimeout(() => {
          this.loading = false;
        }, 3200);
      } catch (error) {
        this.mensaje = "El documento adjuntado no es un Recibo por honorarios, selecciona otro";
        this.error = false;
        this.loading = false;
        Swal.fire({
          title: "ERROR",
          text: this.mensaje,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    };

    fileReader.readAsText(file);
  }


  
  CompletarCampos() {
    if(this.adquirente.Estado !=="X"){
    this.form.controls["idAdquirente"].setValue(this.adquirente.idEmpresa);
    this.form.controls["rucAdquirente"].setValue(this.adquirente.Num_Doc_Identificacion);
    
  
    

    this.form.controls["razSocial"].setValue(this.adquirente.Razon_Social);

    this.form.controls["dirFiscal"].setValue(this.adquirente.Direccion_Fiscal);

    this.form.controls["departamento"].setValue(this.adquirente.Departamento);

    this.form.controls["provincia"].setValue(this.adquirente.Provincia);

    this.form.controls["distrito"].setValue(this.adquirente.Distrito);
    }

    // proveedor
    if(this.proveedor.Estado !=="X"){
    this.form.controls["rucProveedor"].setValue(this.proveedor.Num_Doc_Identificacion);

    this.form.controls["idProveedor"].setValue(this.proveedor.idEmpresa);

    this.form.controls["razSocialProveedor"].setValue(this.proveedor.Razon_Social);

    this.form.controls["dirFiscalProveedor"].setValue(this.proveedor.Direccion_Fiscal);

    this.form.controls["departamentoProveedor"].setValue(this.proveedor.Departamento);

    this.form.controls["provinciaProveedor"].setValue(this.proveedor.Provincia);

    this.form.controls["distritoProveedor"].setValue(this.proveedor.Distrito);
    }
   

    // Campos Obligatorios
    let serie = this.xml2["ID"];
    let SerieNumero = serie.split("-", 2);
    this.form.controls["Fecha_Emision"].setValue(this.xml2["IssueDate"].trim());
    this.form.controls["Serie"].setValue(SerieNumero[0].trim());
    this.form.controls["Numero"].setValue(SerieNumero[1].trim());

    if (this.MONEDA =='USD'){
      this.monedaElement = this.Label_id_dolares;
      this.form.controls["Moneda"].setValue(3);
    }else {
      this.monedaElement = this.Label_id_soles;
      this.form.controls["Moneda"].setValue(2);
    }


    this.form.controls["Total_Honorarios"].setValue(
      this.xml2["TaxTotal"]["TaxSubtotal"]['TaxableAmount'].trim()
    );
    this.form.controls["Retencion_Importe"].setValue(
      this.xml2["TaxTotal"]["TaxAmount"].trim()
    );
    this.form.controls["Total_Recibido"].setValue(
      this.xml2["LegalMonetaryTotal"]["PayableAmount"].trim()
    );


    this.tranformarDecimal('Total_Honorarios');
    this.tranformarDecimal('Retencion_Importe');
    this.tranformarDecimal('Total_Recibido');
  }


  limpiarCampos() {
    this.form.reset();
  }

  validarProveedor(idProveedor:string){

    this.proveedor = {};

   
    this.negociabesService.validarEmpresaExistente(idProveedor).subscribe(
      data => {
        if (data == null) {
          this.error1 = true;
          this.mensaje1 = "El proveedor no existe.";
        } else {
          this.proveedor = data;
          
          if(this.proveedor.Estado == "X" ) {
            this.error1 = true;
              this.mensaje1 = "Proveedor bloqueado.";
            return 
          } else {
            this.error1 = false; 
            this.CompletarCampos();
          }

        }
      },
    );
  }

  validarEmpresa(ruc: string) {

    this.adquirente = {};

    


    this.negociabesService.validarEmpresaExistenteADQ(ruc).subscribe(
      data => {
        if (data == null) {
          this.error2 = true;
          this.mensaje2 = "El adquirente no existe.";
        } else {
          this.adquirente = data; 
          this.error2 = false;
          if(this.adquirente.Estado == "X") {
            this.error2 = true;
            return this.mensaje2 = "Adquirente bloqueado.";
          } else {
            this.CompletarCampos();
          }
        }
      },
    );
  }

  transformarImporteCuotas(){

    let cantidad = this.cuotasform.controls["Cuotas"]["controls"].length;

    for (let index = 0; index <= cantidad-1; index++) {

       this.cuotasform.controls["Cuotas"]["controls"][index]["controls"]["Importe"].setValue(this.cortarComa(this.cuotasform.controls["Cuotas"]["controls"][index]["controls"]["Importe"].value));
       this.cuotasform.controls["Cuotas"]["controls"][index]["controls"]["Importe_Pendiente"].setValue(this.cortarComa(this.cuotasform.controls["Cuotas"]["controls"][index]["controls"]["Importe"].value));
  

    }
    
  }

  

  calcularAjuste(){

    let precioVenta = this.cortarComa(this.form.controls['Total_Recibido'].value);
    let VNPP = this.cortarComa(this.form.controls['VNPP'].value);
 
    let otrosDescuentos =   this.cortarComa(this.form.controls['Otros_Descuentos'].value);
    
    let VNPPmenosPV = Number(VNPP-precioVenta);

    let sumaImportes =    Number(otrosDescuentos); 

    let ajuste = Number(VNPPmenosPV - (- sumaImportes)) 

    this.form.controls['Ajustes'].setValue(ajuste.toFixed(2));

  }


  validarCuotas(termino?: string) {
    if(this.form.controls["cuotas"].value){
      this.form.controls["Numero_Cuotas"].setValue(this.cuotasform.controls["Cuotas"]["controls"].length);
    }else{
      this.form.controls["Numero_Cuotas"].setValue(1);
    }
  }

  agregarCuotas(){
  
  
    let cantidad = this.cuotasform.controls["Cuotas"]["controls"].length;
    this.cuotasform.controls["Cuotas"]["controls"].push(
      
      new FormGroup({   
        'Fecha_de_Pago' : new FormControl('',  Validators.required),
      'Importe' : new FormControl('', [ Validators.required,  Validators.pattern("^^[0-9.,]+$")])
    })


    )

    this.form.controls['Numero_Cuotas'].setValue(cantidad+1);
    this.longitud =   this.cuotasform.controls["Cuotas"]["controls"].length;
  }

  eliminarCuotas(){
  
    let cantidad = this.cuotasform.controls["Cuotas"]["controls"].length;
    (<FormArray> this.cuotasform.controls["Cuotas"]).removeAt (cantidad-1);
       
    this.form.controls['Numero_Cuotas'].setValue(cantidad-1);
    this.longitud =   this.cuotasform.controls["Cuotas"]["controls"].length;
}

  transformarFechas(){

    let cantidad = this.cuotasform.controls["Cuotas"]["controls"].length;

    for (let index = 0; index <= cantidad-1; index++) {
       this.cuotasform.controls['Cuotas']['controls'][index]['controls']['Fecha_de_Pago']
       .setValue(this.datePipe.transform( this.cuotasform.controls['Cuotas']['controls'][index]['controls']['Fecha_de_Pago'].value ,"yyyy-MM-dd" ));
       

    }
    


  }

  tranformarDecimal(control:any , decimal?:number){
  
    let valor;
    if(decimal){
      valor =  this.decimalPipe.transform(this.cortarComa(  this.form.controls[`${control}`].value), `1.${decimal}-${decimal}`);
    } else{
    
      valor =  this.decimalPipe.transform(this.cortarComa(this.form.controls[`${control}`].value), `1.2-2`); 
    }
    this.form.controls[`${control}`].setValue(valor);
  
   }

  tranformarDecimalCuotas(indice:number ,control:any , decimal?:number){
  

    let valor ;
    if(decimal){
      
      valor =  this.decimalPipe.transform(this.cortarComa( 
              this.cuotasform.controls['Cuotas']['controls'][indice]['controls'][`${control}`].value  )
                , `1.${decimal}-${decimal}`);
      
    }else{
      
      valor =  this.decimalPipe.transform(this.cortarComa( 
        this.cuotasform.controls['Cuotas']['controls'][indice]['controls'][`${control}`].value  )
          , `1.2-2`);
      
    }
  
    this.cuotasform.controls['Cuotas']['controls'][indice]['controls'][`${control}`]
    .setValue( valor);
  
  
   }

   cortarComa(numero:any):number{

    let cortado = numero.toString().replace(/,/gi,'');
    return Number(cortado);
 }


 completarTotalRecibido() {
  let totalHonorarios = Number(this.cortarComa(this.form.get("Total_Honorarios").value));
  let retencion =  Number(this.cortarComa(this.form.get("Retencion_Importe").value));
  let totalRetencion = (Number(totalHonorarios) - Number(retencion));

  this.form.get("Total_Recibido").setValue(totalRetencion.toFixed(2));
  }

  onClick(tipo:string,id:string){
    
    const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
    
    fileUpload.onchange = () => {
      this.aBinario(fileUpload.files)
      this.onChange(fileUpload.files)
    };
  fileUpload.click();
  }

  aBinario(fileList: FileList){

    let file = fileList[0];
    let fileReader: FileReader = new FileReader();
    var base64;
    var archivo64;
    var self = this;
    fileReader.onload =  function(fileLoadedEvent) {
              base64 = fileLoadedEvent.target['result'];
              archivo64 = base64.split(',',2);
              self.archivoEnBase64 = archivo64[1];
           };
        fileReader.readAsDataURL(file);


  }

  goBack(){
    this.loginService.clickGuard = true;
    this.router.navigate(['/negociables/recibo/listado']);
   }


}
